/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListAIDetections } from "../funcs/accessListAIDetections.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListAIDetectionsResult } from "../models/components/listaidetectionsresult.js";
import {
  Category,
  ListAIDetectionsRequest,
  ListAIDetectionsSecurity,
} from "../models/operations/listaidetections.js";
import { unwrapAsync } from "../types/fp.js";
export type AiDetectionsQueryData = ListAIDetectionsResult;

export function prefetchAiDetections(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAIDetectionsRequest | undefined,
  security?: ListAIDetectionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAiDetectionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAiDetectionsQuery(
  client$: GramCore,
  request?: ListAIDetectionsRequest | undefined,
  security?: ListAIDetectionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<AiDetectionsQueryData>;
} {
  return {
    queryKey: queryKeyAiDetections({
      category: request?.category,
      directoryGroupId: request?.directoryGroupId,
      gramSession: request?.gramSession,
    }),
    queryFn: async function aiDetectionsQueryFn(
      ctx,
    ): Promise<AiDetectionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListAIDetections(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAiDetections(
  parameters: {
    category?: Category | undefined;
    directoryGroupId?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listAIDetections", parameters];
}
